import request from "@/utils/request";

export default function adminGetNewsHistory(current=1, pageSize=10,params) {
    return request({
        url: `/newsHistory/agencyGetNewsHistory/`+current+`/`+pageSize,
        method: 'get',
        params
    })
}
